import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '../Icon';
import { AutoplayCarousel } from '../AutoplayCarousel';
import styles from './FeedbackList.css';

const REVIEWS = [
    {
        id: 1,
        title: 'As easy as talking to an old friend',
        quote: 'I’m not big on technology, but Boundly made it easy. I simply talked into my phone like I was chatting with an old friend. I want my kids to have our family stories.',
        name: 'Paul',
        date: 'September',
        initial: 'P',
        avatarColor: '#944343'
    },
    {
        id: 2,
        title: 'Mom’s stories we never knew we were missing',
        quote: 'I got this for my mom and she remembered so many stories from her childhood, her first love, her whole life. We never knew half of it. The whole family is in awe. Best gift we’ve ever given her.',
        name: 'Natalie',
        date: 'September',
        initial: 'N',
        avatarColor: '#5c8c5e'
    },
    {
        id: 3,
        title: 'A bridge to my kids, one story at a time',
        quote: 'My kids live abroad, and I don’t know when I’ll see them next. Perhaps through my stories, we’ll feel more connected.',
        name: 'Ruby',
        date: 'September',
        initial: 'R',
        avatarColor: '#3a6194'
    }
];

function FeedbackList({ reviews = REVIEWS }) {
    return (
        <AutoplayCarousel className={styles.carousel}>
            {reviews.map(review => (
                <div className={styles.card} key={review.id}>
                    <p className={styles.title}>{review.title}</p>
                    <p className={styles.quote}>“{review.quote}”</p>
                    <div className={styles.footer}>
                        <div className={styles.author}>
                            <span className={styles.avatar} style={{ backgroundColor: review.avatarColor }}>{review.initial}</span>
                            <p className={styles.authorText}><span className={styles.name}>{review.name},</span> {review.date}</p>
                        </div>
                        <span className={styles.badge}>
                            <Icon name='verifiedFill' className={styles.badgeIcon} />
                            Verified
                        </span>
                    </div>
                </div>
            ))}
        </AutoplayCarousel>
    );
}

FeedbackList.propTypes = {
    reviews: PropTypes.array
};

export {
    FeedbackList
};
